// extracted by mini-css-extract-plugin
export default {"container":"Galery_container__GrR-h","wraper":"Galery_wraper__FNBMZ"};